import { getProducts, getAgencyInfo } from '@/service';
import { INSURANCE_ROUTER_MAP } from '@/typings';
import { history } from 'umi';

export default {
  namespace: 'global',
  state: {
    languages: [
      {
        title: 'VN',
        key: 'vi-VN',
      },
      {
        title: 'EN',
        key: 'en-US',
      },
    ],
    currentLang: !localStorage.getItem('selected_lang')?.length
      ? 'vi-VN'
      : localStorage.getItem('selected_lang'),
    token: '',
    userInfo: {},
    productData: {},
    product: {},
    products: [],
    category: '',
    plans: [],
    plan: {}, // 某个plan
    menuKey: '', // 当前菜单key
    policies: [],
    policyDetail: {},
    cursor: '0', // earning commission列表
    hc_plan_id: 1, // hospital cash plan id
  },
  reducers: {
    setData(state: GlobalState, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {
    *getAgentInfo(_: PayloadType, { call, put }: any) {
      const { userInfo } = yield call(getAgencyInfo);
      yield put({
        type: 'setData',
        payload: {
          userInfo,
        },
      });
    },
    *getProductData({ payload }: PayloadType, { call, put }: any): any {
      const { pathname, query } = history.location;
      const data = yield call(getProducts, payload);
      yield put({
        type: 'setData',
        payload: {
          productData: data,
        },
      });

      yield put({
        type: 'getProducts',
        payload: {
          key: pathname.split('/')[2],
        },
      });

      if (
        pathname.includes('product-plan') ||
        pathname.includes('product-hc-plan') ||
        pathname.includes('product-option')
      ) {
        const { product_id, plan_id }: any = query;
        yield put({
          type: 'getProduct',
          payload: {
            product_id: +product_id,
          },
        });

        if (plan_id) {
          yield put({
            type: 'getPlanApplyForm',
            payload: {
              plan_id: +plan_id,
            },
          });
        }
      }
    },

    // 初始化获取产品列表、获取用户信息
    *init(_: PayloadType, { put }: any) {
      yield put({
        type: 'getProductData',
      });

      yield put({
        type: 'getAgentInfo',
      });
    },

    // 获取产品类型
    *getProducts({ payload }: PayloadType, { put, select }: any) {
      const key = payload.key;
      const { productData } = yield select((state: ReduxState) => state.global);
      const { products, category } = productData[INSURANCE_ROUTER_MAP[key]];
      yield put({
        type: 'setData',
        payload: {
          products,
          category,
        },
      });
    },

    // 获取选中的产品
    *getProduct({ payload }: PayloadType, { put, select }: any) {
      const product_id = payload.product_id;
      const { products } = yield select((state: ReduxState) => state.global);
      const product = products.find(
        ({ id }: { id: number }) => id === product_id,
      );
      yield put({
        type: 'setData',
        payload: {
          product,
        },
      });
    },

    // 获取产品的plan
    *getPlanApplyForm({ payload }: PayloadType, { put, select }: any) {
      const pl_id = payload.plan_id;
      const { product } = yield select((state: ReduxState) => state.global);
      yield put({
        type: 'setData',
        payload: {
          plan: product.plans.find(
            ({ plan_id }: { plan_id: number }) => plan_id === pl_id,
          ),
        },
      });
    },

    //跳转到one pay支付页面或者邦卡页面
    *toRedirectNewPage({ payload }: PayloadType, { select }: any) {
      let url = payload.url;
      let { currentLang } = yield select((state: ReduxState) => state.global);
      const lang = localStorage.getItem('selected_lang');
      if (currentLang !== lang) currentLang = lang;
      if (currentLang === 'vi-VN') {
        url = `${url}&lang=vi-VN`;
      } else {
        url = `${url}&lang=en-US`;
      }
      window.open(url, '_blank');
    },

    // *reRequestWhenChangeLanguage({ payload }: PayloadType, { put }: any): any {
    //   const { pathname, query } = history.location;
    //   const { currentLang } = payload;

    //   localStorage.setItem('selected_lang', currentLang);

    //   // 切换语言的同时，更新request header
    //   updateRequest(currentLang === 'vi-VN' ? 'vi' : 'en');

    //   yield put({
    //     type: 'setData',
    //     payload: {
    //       currentLang,
    //     },
    //   });

    //   // 非login页面，切换语言后重新请求product数据
    //   if (!pathname.includes('/login')) {
    //     //登录页面切换语言的时候，不重新获取产品信息
    //     yield put({
    //       type: 'getProductData',
    //     });
    //   }

    //   // policy页面
    //   if (pathname.includes('/customers/policies')) {
    //     // policy detail页面
    //     if (pathname.includes('/customers/policies/detail')) {
    //       const { quote_id }: any = query;
    //       yield put({
    //         type: 'getPolicyDetail',
    //         payload: {
    //           quote_id,
    //         },
    //       });
    //     } else {
    //       // policy页面
    //       const { id }: any = query;
    //       yield put({
    //         type: 'getCustomerPolicies',
    //         payload: {
    //           id,
    //         },
    //       });
    //     }
    //   }
    // },
  },
};
